var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.349,
    height: 52.149,
    viewBox: "0 0 36.349 52.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18719",
    "data-name": "Group 18719",
    transform: "translate(-471.078 -1402.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-pen-tool",
    "data-name": "Icon feather-pen-tool",
    transform: "translate(489.597 1431.231) rotate(81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25160",
    "data-name": "Path 25160",
    d: "M0,6.907,6.907,0l2.96,2.96L2.96,9.867Z",
    transform: "translate(9.867 9.867)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25161",
    "data-name": "Path 25161",
    d: "M15.786,10.853l-1.48-7.4L0,0,3.453,14.306l7.4,1.48Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25162",
    "data-name": "Path 25162",
    d: "M0,0,7.485,7.485",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25163",
    "data-name": "Path 25163",
    d: "M3.947,1.973A1.973,1.973,0,1,1,1.973,0,1.973,1.973,0,0,1,3.947,1.973Z",
    transform: "translate(6.907 6.907)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-tap-and-play",
    "data-name": "Icon material-tap-and-play",
    d: "M3,52.5ZM37.789,1.523,14.6,1.5A4.651,4.651,0,0,0,9.958,6.136V23.221c1.6.371,13.482,5.3,20.8,17.688a30.139,30.139,0,0,1,2.2,9.273h4.824a4.651,4.651,0,0,0,4.639-4.636V6.136a4.631,4.631,0,0,0-4.639-4.613Z",
    transform: "translate(464.5 1401.231)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.24aa6dcc82f663ae6efd98f304bc4dd4.svg";
export { ForwardRef as ReactComponent };